<template>
	<div class="av-status">
		<div class="percent">
			<svg id="loadCircle">
				<circle cx="70" cy="70" r="70"></circle>
				<circle cx="70" cy="70" r="70"></circle>
			</svg>
			<div class="number">
				<div class="detected">{{ detected }}</div>
				<div class="all">/ {{ total }}</div>
			</div>
		</div>
		<div class="text-box">
			<div class="icon">
				<img class="warning-img">
			</div>
			<div class="text">{{ detected }} AV(s) detected virus in this file</div>
		</div>
		
	</div>
</template>


<script>
export default {
	name: 'StatusBar',
	props: [
		'results'
	],
	data() {
		return {
			detected: 0,
			total: 0,
			maxDetected: 0,
			timerInterval: null,
		}
	},
	methods: {
		onTotalReached() {
			clearInterval(this.timerInterval);
		},
		startDetecting() {
			this.detected = 0
			if (this.maxDetected != 0){
					this.timerInterval = setInterval(() => {
					this.detected += 1;
				}, 300);
			}
			
		},
		setProperSize() {
			const loadCircle = document.querySelector('#loadCircle')
			const progressCircle = loadCircle.getElementsByTagName(['circle'])[1]
			const percentage = this.detected * 100 / this.total;
			progressCircle.style.strokeDashoffset = 'calc(440 - (440 * ' + percentage +') / 100)'
		}
	},
	mounted() {
		this.total = this.results.length
		this.maxDetected = this.results.filter((item) => { return item.virus != '' }).length
		this.startDetecting()
	},
	watch: {
		detected: function (newValue) {
			if (newValue >= this.maxDetected) {
				this.onTotalReached();
			}
			this.setProperSize()
		},
	}
}
</script>